<template>
	<div class="pageBg">
		<div class="n-top-bg">
			<img src="@/assets/images/news/16-1_02.jpg" />
		</div>
		<div class="n-world-bg">
			<div class="n-world-box">
				<div class="n-title">{{title}}</div>
				<div class="n-h">{{titleTime}}</div>
				<div v-html="richContent"></div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		data() {
			return {
				id:0,
				title:'',
				titleTime:'',
				richContent:''
			}
		},
		mounted() {
			var self = this
			// 获取路由参数
			let newInfo = this.$route.query;
			self.id = newInfo.id
			self.netNewsInfo()
		},
		methods:{
			//获取新闻详情
			netNewsInfo(){
				var self = this
				let param = {}
				var url = "https://issks.com/api/news/show/newsId/"+self.id
				
				axios.get(url, param).then(res => {
					const data = res.data.data
					console.log(data)
					self.title = data.title
					self.richContent = data.content
					self.titleTime = self.timeFormat(data.updatetime)
				}).catch(err => {
				 
				})
			},
			//时间格式化
			timeFormat(timeDate){
				var timeNum = new Date(timeDate*1000)
				let year = timeNum.getFullYear()
				let month = timeNum.getMonth() + 1
				let date = timeNum.getDate()
				let hours = timeNum.getHours()
				let minute = timeNum.getMinutes()
				let second = timeNum.getSeconds()
			
				if (month < 10) { month = '0' + month }
				if (date < 10) { date = '0' + date }
				if (hours < 10) { hours = '0' + hours }
				if (minute < 10) { minute = '0' + minute }
				if (second < 10) { second = '0' + second }
				return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
			},
		}
	}
</script>

<style>
	.n-top-bg{
		width: 100%;
	}
	.n-world-bg{
		width: 100%;
		margin-top: 5vw;
	}
	.n-world-box{
		width: 60%;
		margin: 0 auto;
		background-color: #fff;
		text-align: left;
	}
	.n-world-box img{
		width: 80% !important;
		margin: 0 auto;
	}
	.n-title{
		text-align: center;
		font-weight: bold;
	}
	.n-h{
		margin-bottom: 2rem;
		text-align: right;
		color: #8aba46;
	}
	@media screen and (min-width:755px) {
		.n-title{
			font-size: 2vw;
		}
		.n-h{
			font-size: 1.8vw;
		}
		span {
			font-size: 1.2vw !important; /* 根据需要调整字体大小 */
		}
	}
	@media screen and (max-width:750px) {
		.n-title{
			font-size: 1rem;
		}
		.n-h{
			font-size: 1rem;
		}
		.n-world-box{
			width: 80%;
		}
	}
</style>